<gipi-abstract-form id="dialogIntegrations"
                    name="dialogIntegrations"
                    [dialog]="true">

    <gipi-toolbar mat-dialog-title
                  id="toolbarDialogIntegrations">
        Integração da Smart TEF
    </gipi-toolbar>

    <div mat-dialog-content
         fxLayout="column"
         fxLayoutGap="16px"
         style="height: 100%;">
        <div fxLayout="row"
             fxLayout.lt-md="column"
             fxLayoutGap="16px">
            <gipi-select-button label="Tipo de integração"
                                gipi-primary
                                id="smartTefTypeIntegration"
                                name="smartTefTypeIntegration"
                                optionLabel="label"
                                optionValue="type"
                                [disabled]="loading"
                                [required]="true"
                                [options]="typeIntegrationList"
                                [(ngModel)]="typeIntegrationValue"
                                fxFlex="30"
                                fxFlex.lt-md="100">
            </gipi-select-button>
            <itss-input label="URL Base"
                        id="smartTefBaseUrl"
                        name="smartTefBaseUrl"
                        [required]="true"
                        [disabled]="loading"
                        [(ngModel)]="smartTefConfig.baseUrl"
                        [maxlength]="255"
                        fxFlex
                        fxFlex.lt-md="100">
            </itss-input>
        </div>

        <ng-container *ngIf="typeIntegrationValue === 'AUTHENTICATED'">
            <div fxLayout="row"
                 fxLayout.lt-sm="column"
                 fxLayoutGap="16px">
                <itss-input label="GW Token da integração"
                            id="smartTefGwIntegrationToken"
                            name="smartTefGwIntegrationToken"
                            [required]="true"
                            [disabled]="loading"
                            [(ngModel)]="smartTefConfig.gwIntegrationToken"
                            [maxlength]="255"
                            fxFlex
                            fxFlex.lt-md="100">
                </itss-input>
                <itss-input label="GW Token da loja"
                            id="smartTefGwStoreToken"
                            name="smartTefGwStoreToken"
                            [required]="true"
                            [disabled]="loading"
                            [(ngModel)]="smartTefConfig.gwStoreToken"
                            [maxlength]="255"
                            fxFlex
                            fxFlex.lt-md="100">
                </itss-input>
            </div>
            <itss-input label="JWT Token da integração"
                        id="smartTefJwtIntegrationToken"
                        name="smartTefJwtIntegrationToken"
                        [required]="true"
                        [disabled]="loading"
                        [(ngModel)]="smartTefConfig.jwtIntegrationToken"
                        [maxlength]="1000"
                        fxFlex
                        fxFlex.lt-md="100">
            </itss-input>
        </ng-container>

        <ng-container *ngIf="typeIntegrationValue === 'UNAUTHENTICATED'">
            <div fxLayout="row"
                 fxLayout.lt-sm="column"
                 fxLayoutGap="16px">
                <itss-input label="GW Token da loja"
                            id="smartTefGwIntegrationToken"
                            name="smartTefGwIntegrationToken"
                            [required]="true"
                            [disabled]="loading"
                            [(ngModel)]="smartTefConfig.gwStoreToken"
                            [maxlength]="255"
                            fxFlex
                            fxFlex.lt-md="100">
                </itss-input>
                <itss-input label="JWT Token da loja"
                            id="smartTefJwtIntegrationToken"
                            name="smartTefJwtIntegrationToken"
                            [required]="true"
                            [disabled]="loading"
                            [(ngModel)]="smartTefConfig.jwtStoreToken"
                            [maxlength]="1000"
                            fxFlex
                            fxFlex.lt-md="100">
                </itss-input>
            </div>
        </ng-container>
    </div>

    <div mat-dialog-actions
         fxLayout="row"
         fxLayoutAlign="end center"
         fxLayoutGap="16px">
        <gipi-button label="Confirmar"
                     gipi-primary
                     id="btnIntegrationsConfirm"
                     [disabled]="loading"
                     [loading]="loading"
                     (click)="confirm()"
                     fxFlex="20"
                     fxFlex.lt-sm="30">
        </gipi-button>
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnIntegrationsReturn"
                     (click)="close()"
                     fxFlex="20"
                     fxFlex.lt-sm="30">
        </gipi-button>
    </div>
</gipi-abstract-form>